import Link from 'next/link'
import { Button, Icon, Loader } from 'semantic-ui-react'
import { createApplication } from '@src/graphql/mutations'
import { useMutation, gql, useQuery } from '@apollo/client'
import { v4 as uuid } from 'uuid'
import { getJobSeekerIdForUser } from 'queries'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useAuth } from '@src/auth'
import AppLink from '@components/JobsViewer/AppLink'
import CoverLetterButton from '@components/JobsViewer/CoverLetterButton'
import ResumeLink from '../JobsViewer/ResumeLink'

export default function ApplyButton({ job, fluid, applicationPage, ...size }) {
  const [jobId, setJobId] = useState(job?.id)

  const scrapedUrl = job?.scrapedUrl

  const { user, isEnterprise } = useAuth()
  const [applied, setApplied] = useState(false)
  const [apply, { data: updateData, loading, error, reset }] = useMutation(
    gql(createApplication),
  )

  const { data: userData, loading: jobSeekerIdLoading } = useQuery(
    gql(getJobSeekerIdForUser),
    {
      variables: { userId: user?.username },
    },
  )

  const jobSeekerId = userData?.getUserById?.jobSeeker?.id

  useEffect(() => {
    setJobId(job?.id)
    setApplied(false)
  }, [job])

  useEffect(() => {
    async function getApplication() {
      if (userData?.getUserById?.jobSeeker?.id) {
        try {
          const res = await axios.post('/api/candidate/has_applied', {
            jobId: jobId,
            jobSeekerId: userData?.getUserById?.jobSeeker?.id,
          })

          console.log('res: ', res)

          setApplied(res?.data?.hasApplied)
        } catch (error) {
          console.log('errrr: ', error)
        }
      }
    }
    getApplication().catch(console.error)
  }, [userData, jobId])

  useEffect(() => {
    if (updateData && !applied) {
      setApplied(true)
    }
  }, [updateData])

  const applyToJob = () => {
    const vars = {
      variables: {
        input: {
          id: uuid(),
          jobId: jobId,
          jobSeekerId,
        },
      },
    }
    console.log('vars: ', vars)
    apply(vars)
  }

  const isEnterpriseUser = isEnterprise()

  if (isEnterpriseUser) return null

  if (loading) {
    return (
      <Button fluid={fluid} circular color="blue" disabled {...size}>
        Apply Now{' '}
        <Loader
          size="mini"
          inverted
          active
          inline
          style={{ marginLeft: '8px', marginRight: '0' }}
        ></Loader>
      </Button>
    )
  }

  if (applicationPage) {
    return (
      <div style={{ display: "flex", borderTop: "1px solid lightgray", paddingTop: "10px" }}>
        <AppLink text={"View Form"} post={job} dashboardCard={true} mini={false} />
        <CoverLetterButton text={"Cover Letter"} post={job} dashboardCard /> 
        <ResumeLink text={"Resume"} post={job} dashboardCard />
      </div>
    )    
  }

  if (scrapedUrl) {
    return (
      <a target="_blank" href={scrapedUrl} rel="noopener noreferrer">
        <Button fluid={fluid} circular color="blue" {...size}>
          Apply Now{' '}
          <Icon
            name="location arrow"
            style={{ marginLeft: '8px', marginRight: '0' }}
          />
        </Button>
      </a>
    )
  }

  if (!user) {
    return (
      <Link href="/signup" passHref>
        <a>
          <Button fluid={fluid} circular color="blue" {...size}>
            Apply Now{' '}
            <Icon
              name="location arrow"
              style={{ marginLeft: '8px', marginRight: '0' }}
            />
          </Button>
        </a>
      </Link>
    )
  }

  if (applied) {
    return (
      <Button fluid={fluid} circular disabled color="blue" {...size}>
        Applied{' '}
        <Icon name="check" style={{ marginLeft: '8px', marginRight: '0' }} />
      </Button>
    )
  }

  return (
    <Button onClick={applyToJob} fluid={fluid} circular color="blue" {...size}>
      Apply Now{' '}
      <Icon
        name="location arrow"
        style={{ marginLeft: '8px', marginRight: '0' }}
      />
    </Button>
  )
}
